import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { ITypesSelection } from 'src/app/core/interfaces/types-selection.interface';
import { TexteService } from 'src/app/core/services/texte.service';
import { ItemDto, ApiService, PathologieDto, RefDto } from 'src/app/core/services/api.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { IRendezvous } from 'src/app/core/interfaces/rendezvous.interface';
import { ToolboxService } from 'src/app/core/services/toolbox.service';

export interface Food {
  value: string;
  viewValue: string;
}

@Component({
    selector: 'app-rendez-vous-form',
    templateUrl: './rendez-vous-form.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RendezVousFormComponent implements OnInit {

  @Input() typesSelected: ITypesSelection;
  public rendezvousForm: FormGroup;

  public specialite: RefDto;
  public specialites: RefDto[] = [];

  public pathologie: PathologieDto;
  public pathologies: PathologieDto[] = [];
  private allPathologies: PathologieDto[] = [];

  public demande: ItemDto;
  public demandes: ItemDto[] = [];

  constructor(
    public texteService: TexteService,
    private apiService: ApiService,
    private toolboxService: ToolboxService
  ) { }

  ngOnInit(): void {
    this.apiService.getSpecialites().subscribe(data => {
      this.specialites = data;
    });

    this.apiService.getPathologies().subscribe(data => {
      this.allPathologies = data;
    });

    this.apiService.getTypeDemandes().subscribe(data => {
      this.demandes = data.filter(d => d.code !== 'NOU');
    });

    this.buildForm();
  }

  private buildForm() {
    this.rendezvousForm = new FormGroup({
      specialite: new FormControl('', Validators.required),
      pathologie: new FormControl(''),
      demande: new FormControl('', Validators.required),
      dateRendezvous: new FormControl('', Validators.required),
      heure: new FormControl('', Validators.required),
    });
  }

  public isValid(): boolean {
    return this.rendezvousForm.valid;
  }

  onSpecialiteChanged(event) {
    this.pathologies = this.allPathologies.filter(p => p.specialite.code === event.value.code);
    if (this.pathologies.length > 0) {
      this.pathologies = this.toolboxService.arrayInsert(
        this.pathologies,
        this.allPathologies.find(p => p.code === 'AUTRE'),
        this.pathologies.length
      );
    }
  }

  public getForm(): IRendezvous {
    const date = this.rendezvousForm.get('dateRendezvous').value as Date;
    date.setUTCDate((this.rendezvousForm.get('dateRendezvous').value as Date).getDate());
    date.setUTCHours(this.rendezvousForm.get('heure').value.split(':')[0]);
    date.setUTCMinutes(this.rendezvousForm.get('heure').value.split(':')[1]);

    return {
      specialite: this.rendezvousForm.get('specialite').value,
      pathologie: this.rendezvousForm.get('pathologie').value,
      demande: this.rendezvousForm.get('demande').value,
      dateRendezvous: date,
    } as IRendezvous;
  }
}
